import LoginPage from "../pages/LoginPage";
// import Home from "../pages/Home";
// import StartPage from '../pages/StartPage'
// import AboutPage from "../pages/AboutPage";
// import MyProjPage from "../pages/MyProjPage";
// import NetWorkPage from "../pages/NetWorkPage";
// import DeepNetPage from "../pages/DeepNetPage";


import Settings from "../pages/Settings"
import TestPage from "../pages/TestPage"
import VacancyListPage from "../pages/VacancyListPage"

import CourseDetail from "../pages/CourseDetail"


import HomePage from "../pages/LandingSet/HomePage"
import CourseGridPage from "../pages/LandingSet/CourseGridPage"
import CourseDetailsPage from "../pages/LandingSet/CourseDetailsPage"
import PublicCourseGridPage from "../pages/LandingSet/PublicCourseGridPage"
import NewsPage from "../pages/LandingSet/NewsPage"
import NewsDetailsPage from "../pages/LandingSet/NewsDetailsPage"

import LoginNewPage from "../pages/LandingSet/LoginNewPage"
import RegistrationPage from "../pages/LandingSet/RegistrationPage"
import ForgotPasswordPage from "../pages/LandingSet/ForgotPasswordPage"

import CourseGrafPage from "../pages/LandingSet/courses/CourseGrafPage"
import CourseBugalterPage from "../pages/LandingSet/courses/CourseBugalterPage"


import CourseCallPage from "../pages/LandingSet/courses/CourseCallPage"
import CourseSellPage from "../pages/LandingSet/courses/CourseSellPage"
import CourseTargetPage from "../pages/LandingSet/courses/CourseTargetPage"
import MyCourseDetailsPage from "../pages/LandingSet/MyCourseDetailsPage";
import CreateMyCoursePage from "../pages/LandingSet/CreateMyCoursePage";
import MyTeacherCourseDetailsPage from "../pages/LandingSet/MyTeacherCourseDetailsPage";

import ContactPage from "../pages/LandingSet/ContactPage";
import DonatePage from "../pages/LandingSet/DonatePage";
import AboutUsPage from "../pages/LandingSet/AboutUsPage";
import VacanciesPage from "../pages/LandingSet/VacanciesPage";
import MojuPage from "../pages/LandingSet/MojuPage";

import CourseAIPage from "../pages/LandingSet/courses/CourseAIPage";
import GameMeetingPage from "../pages/LandingSet/courses/publicCourses/GameMeetingPage";
import ModernPublicCourseDetailsComponent from "../components/NewView/RootComponents/courses/publicCourses/ModernPublicCourseDetailsComponent";
import CabinetRoadmapPage from "../pages/CabinetRoadmapPage";
import ApplicationStatusPage from "../pages/ApplicationStatusPage";
import ProgramCalendarPage from "../pages/ProgramCalendarPage";
import AdminApplicationsPage from "../pages/AdminApplicationsPage";
import AdminCalendarPage from "../pages/AdminCalendarPage";
import ChatPage from "../pages/ChatPage"; // community and private chats
import SelfCoursesPage from "../pages/SelfCoursesPage";
import SelfCourseLearnPage from "../pages/SelfCourseLearnPage";
import AdminSelfCoursesPage from "../pages/AdminSelfCoursesPage";
import AdminUsersPage from "../pages/AdminUsersPage";
import AdminCareerPage from "../pages/AdminCareerPage";




export const publicRoutes = [
    {path: '/login', element: <LoginPage/>},
    {path: '/loginn', element: <LoginNewPage/>},
    {path: '/forgot-password', element: <ForgotPasswordPage/>},
    {path: '/register', element: <RegistrationPage/>},
    {path: '/registerr', element: <RegistrationPage/>},
    {path: '/start', element: <HomePage/>},
    { path: '/courses', element: <PublicCourseGridPage/> },
    { path: '/news', element: <NewsPage/> },
    { path: '/news/:slug', element: <NewsDetailsPage/> },
    { path: '/course-details:1', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:1" /> },
    { path: '/course-details:2', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:2" /> },
    { path: '/course-details:4', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:4" /> },
    { path: '/course-details:5', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:5" /> },
    { path: '/course-details:6', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:6" /> },
    { path: '/course-details:7', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:7" /> },
    { path: '/course-details:8', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:8" /> },
    { path: '/course-details:9', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:9" /> },
    { path: '/course-details:13', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:13" /> },
    { path: '/course-details:10', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:10" /> },
    { path: '/course-details:11', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:11" /> },
    { path: '/course-details:12', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:12" /> },
    { path: '/course-details:14', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:14" /> },
    { path: '/course-details:15', element: <ModernPublicCourseDetailsComponent coursePath="/course-details:15" /> },

    {path: '/game', element: <GameMeetingPage/>},
    { path: '/vacancies', element: <VacanciesPage/> },
    { path: '/moju', element: <MojuPage/> },
    
    { path: '/pubcourse-grid-page', element: <PublicCourseGridPage/> },


    { path: '/consultations', element: <ContactPage/> },
    { path: '/future-teacher', element: <ContactPage/> },
    { path: '/about', element: <AboutUsPage/> },
    { path: '/donate', element: <DonatePage/> },

    // { path: '/event-details', element: <EventDetailsPage/> },

    
]

export const privateRoutes = [
    {path: '/home', element: <Settings/>},
    {path: '/settings', element: <Settings/>},
    {path: '/vacancylist', element: <VacancyListPage/>},
    {path: '/my-courselist', element: <SelfCoursesPage/>},
    {path: '/self-courses/:id/learn', element: <SelfCourseLearnPage/>},
    { path: '/course/:id', element: <CourseDetail /> },

    {path: '/start', element: <HomePage/>},
    { path: '/courses', element: <PublicCourseGridPage/> },
    { path: '/news', element: <NewsPage/> },
    { path: '/news/:slug', element: <NewsDetailsPage/> },

    { path: '/mycourse-details/:id', element: <MyCourseDetailsPage/> },

    {path: '/test', element: <TestPage/>},
    { path: '/course-grid-page', element: <CourseGridPage/> },
    { path: '/course-details:1', element: <CourseGrafPage/> },
    { path: '/course-details:2', element: <CourseBugalterPage/> },
    { path: '/course-details:4', element: <CourseCallPage/> },
    { path: '/course-details:5', element: <CourseSellPage/> },
    { path: '/course-details:6', element: <CourseTargetPage/> },
    { path: '/course-details:7', element: <CourseAIPage/> },
    { path: '/course-details:8', element: <CourseTargetPage/> },
    { path: '/course-details', element: <CourseDetailsPage/> },
    

    
]


export const studentRoutes = [
    { path: '/calendar', element: <ProgramCalendarPage/> },
    { path: '/chat', element: <ChatPage/> },
    {path: '/home', element: <Settings/>},
    {path: '/settings', element: <Settings/>},
    {path: '/vacancylist', element: <VacancyListPage/>},
    {path: '/my-courselist', element: <SelfCoursesPage/>},
    {path: '/self-courses/:id/learn', element: <SelfCourseLearnPage/>},
    { path: '/course/:id', element: <CourseDetail /> },

    { path: '/mycourse-details/:id', element: <MyCourseDetailsPage/> },
    {path: '/start', element: <HomePage/>},
    { path: '/courses', element: <PublicCourseGridPage/> },
    { path: '/news', element: <NewsPage/> },
    { path: '/news/:slug', element: <NewsDetailsPage/> },

    {path: '/test', element: <TestPage/>},
    { path: '/course-grid-page', element: <CourseGridPage/> },
    { path: '/course-details:1', element: <CourseGrafPage/> },
    { path: '/course-details:2', element: <CourseBugalterPage/> },
    { path: '/course-details:4', element: <CourseCallPage/> },
    { path: '/course-details:5', element: <CourseSellPage/> },
    { path: '/course-details:6', element: <CourseTargetPage/> },
    { path: '/course-details:7', element: <CourseAIPage/> },
    { path: '/course-details', element: <CourseDetailsPage/> },
    { path: '/cabinet/yellow-quest', element: <CabinetRoadmapPage/> },
    
];

export const candidateRoutes = [
    { path: '/application-status', element: <ApplicationStatusPage/> },
    { path: '/settings', element: <Settings/> },
];


// Роутинг для викладачів
export const teacherRoutes = [
    { path: '/admin/users', element: <AdminUsersPage/> },
    { path: '/admin/career', element: <AdminCareerPage/> },
    { path: '/admin/applications', element: <AdminApplicationsPage/> },
    { path: '/admin/calendar', element: <AdminCalendarPage/> },
    { path: '/admin/chat', element: <ChatPage/> },
    { path: '/admin/self-courses', element: <AdminSelfCoursesPage/> },
    {path: '/home', element: <Settings/>},
    {path: '/settings', element: <Settings/>},
    {path: '/vacancylist', element: <VacancyListPage/>},
    {path: '/my-courselist', element: <AdminSelfCoursesPage/>},
    { path: '/course/:id', element: <CourseDetail /> },
    { path: '/courseCreate', element: <CreateMyCoursePage /> },
    {path: '/start', element: <HomePage/>},
    { path: '/courses', element: <PublicCourseGridPage/> },
    { path: '/news', element: <NewsPage/> },
    { path: '/news/:slug', element: <NewsDetailsPage/> },
    

    { path: '/mycourse-details/:id', element: <MyTeacherCourseDetailsPage/> },

    {path: '/test', element: <TestPage/>},
    { path: '/course-grid-page', element: <CourseGridPage/> },
    { path: '/course-details:1', element: <CourseGrafPage/> },
    { path: '/course-details:2', element: <CourseBugalterPage/> },
    { path: '/course-details:4', element: <CourseCallPage/> },
    { path: '/course-details:5', element: <CourseSellPage/> },
    { path: '/course-details:6', element: <CourseTargetPage/> },
    { path: '/course-details:7', element: <CourseAIPage/> },
    { path: '/course-details', element: <CourseDetailsPage/> },
];
